<div class="stick-top">
  <mat-toolbar><mat-icon>cell_tower</mat-icon> Network Profile</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/networkProfiles/0">
      <mat-icon aria-label="Create a new Network Profile">add</mat-icon>
      Create a new Network Profile
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">Code<input [(ngModel)]="filter.code"></div></th>
      <th><div class="vbox">Platform<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">Description<input [(ngModel)]="filter.description"></div></th>
      <th><div class="vbox">Active<input [(ngModel)]="filter.active"></div></th>
      <th><div class="vbox">Hosting Platform<input [(ngModel)]="filter.hostingPlatform"></div></th>
      <th><div class="vbox">Class Code<input [(ngModel)]="filter.classCode"></div></th>
      <th><div class="vbox">Subnet<input [(ngModel)]="filter.subnet"></div></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td>{{element.code}}</td>
      <td><a routerLink="/networkProfiles/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.description}}</td>
      <td>{{element.active}}</td>
      <td>{{hostingPlatformNames.get(element.hostingPlatformId) || ""}}</td>
      <td>{{classNames.get(element.classCodeId) || ""}}</td>
      <td>{{subnetNames.get(element.subnetId) || ""}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
